import { render, staticRenderFns } from "./RestItemHolder.vue?vue&type=template&id=0b0de9e4&scoped=true&"
import script from "./RestItemHolder.vue?vue&type=script&lang=js&"
export * from "./RestItemHolder.vue?vue&type=script&lang=js&"
import style0 from "./RestItemHolder.vue?vue&type=style&index=0&id=0b0de9e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0de9e4",
  null
  
)

export default component.exports